<template>
  <div>
    <img src="../assets/images/logo.svg" width="160px" alt="澄合矿业有限公司">
  </div>
</template>

<script>
export default {
  name: 'LoginHeader',
  props: {
    className: {
      type: String,
      default: 'login-header'
    }
  }
}
</script>

<style lang="less" scoped>
@import '../index.less';

.login-header, .splash_header {
    padding: 20px 24px;
    font-size: 36px;
    border-bottom: 2px solid @primary-color;
    background-color: #fff;
    
    img {
        vertical-align: middle;
    }
}

@media (max-width: 640px) {
    .login-header, .splash_header {
        padding: 16px;
        font-size: 14px;
        line-height: 24px;
        
        img {
            width: 160px;
        }
    }
}
</style>